/**
 * Checks the URL query parameters and takes actions:
 * - If "?set-currency-chf" is present, redirect to set CHF currency
 * - If "?open-cart" is present, open the cart drawer
 * Also calls itself immediately to run on page load.
 */
function checkUrlQueryForCurr() {
  if (window.location.href.indexOf("?set-currency-chf") > -1) {
    setTimeout(() => {
      window.location.href = "?currency=CHF";
    }, 100);
  }
  if (window.location.href.indexOf("?open-cart") > -1) {
    setTimeout(() => {
      document.querySelector("#cart-drawer").show();
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({ path: newurl }, "", newurl);
    }, 500);
  }
}
checkUrlQueryForCurr();